module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?1e9e35036ef9c06cdd99d580171d7f2a";